import React from 'react'
import Link, { navigateTo } from 'gatsby-link'
import Box from "../components/atoms/Box";

import '../theme/contact.sass'

const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Required'
  } else if (values.name.length > 50) {
    errors.name = 'Must be 50 characters or less'
  }
  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  if (!values.message) {
    errors.message = 'Required'
  } else if (values.message.length < 10) {
    errors.message = 'Must be more than 10 characters.'
  }
  return errors
}

const ErrorText = (props) => (
  <span style={{
    color: 'tomato'
  }}>
    {props.text}
  </span>
)

const MyTextInput = ({
  input,
  label,
  type,
  error,
  ...inputProps 
}) => (
  <div className="wrap-input100 rs1-wrap-input100 validate-input">
    <span className="label-input100">{label}</span>
    <input
      type={type}
      {...input}
      {...inputProps}
    />
    <span className="focus-input100"></span>
    { error && <ErrorText text={error} /> }
  </div>
)
const MyTextArea = ({
  input,
  label,
  type,
  error,
  ...inputProps
}) => (
  <div className="wrap-input100 validate-input">
    <span className="label-input100">{label}</span>
    <textarea
      type={type}
      {...input}
      {...inputProps}
    />
    <span className="focus-input100"></span>
    { error && <ErrorText text={error} /> }
  </div>
)

const ContactForm = props => {
  const { handleSubmit, values, errors, submitting, handleChange } = props
  return (
    // <form className="contact-form validate-form" onSubmit={handleSubmit}>
    <form
      className="contact-form validate-form"
      name="contact"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      action="/thanks"
    >
      <input type="hidden" name="bot-field" />
      <input type="hidden" name="form-name" value="contact" />
      {/* <span className="contact-form-title">
        Contact Us
      </span> */}

      <MyTextInput
        name="name"
        type="text"
        label="Name"
        placeholder="your name"
        className="input100"
        value={values.name}
        error={errors.name}
        onChange={handleChange}
      />
      <MyTextInput
        name="email"
        type="email"
        label="Email"
        placeholder="your-email@domain.com"
        className="input100"
        value={values.email}
        error={errors.email}
        onChange={handleChange}
      />
      <MyTextArea
        name="message"
        type="message"
        label="Message"
        placeholder="Anything..."
        className="input100"
        value={values.message}
        error={errors.message}
        onChange={handleChange}
      />

      <div className="container-contact-form-btn">
        <button
          type="submit"
          disabled={submitting}
          className="contact-form-btn"
          onClick={handleSubmit}
        >
          SEND
        </button>
      </div>
    </form>
  )
}



function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class ContactPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        name: '',
        email: '',
        message: '',
      },
      errors: {},
    };
  }
  handleChange = (e) => {
    this.setState({ values: {...this.state.values, [e.target.name]: e.target.value} });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({submitting: true})
    let errors = validate(this.state.values)
    // console.lo
    if (Object.keys(errors).length > 0) {
      this.setState({
        errors,
        submitting: false
      })
      return false
    }
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...this.state.values })
    })
    .then(() => {
      navigateTo('/thanks')
    })
    .catch(error => {
      this.setState({
        submitting: false
      })
      alert(error)
    });

    // .then(function (response) {
    //   console.log(response);
    // })
    // .catch(function (error) {
    //   console.log(error);
    // });

  }
  
  render() {
    return (
      <div className="contactPage">
        <ContactForm
          handleSubmit={this.handleSubmit.bind(this)}
          handleChange={this.handleChange.bind(this)}
          values={this.state.values}
          errors={this.state.errors}
          submitting={this.state.submitting}
        />
      </div>
    )
  }
}

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js